export const LOADING_SHOW = "LOADING_SHOW";
export const LOADING_HIDE = "LOADING_HIDE";

export function show_loading() {
  return {
    type: LOADING_SHOW,
  };
}

export function hide_loading() {
  return {
    type: LOADING_HIDE,
  };
}
